import React from "react";
import icons from "src/design-system/icons";
import GrConfirmDialog from "src/design-system/components/GrConfirmDialog";

// Shared "Are you sure…?" dialog (16 screens). Same props, same Cancel / Agree wording and handlers;
// GymRite confirm look. Red (destructive) when the question is about deleting / removing / leaving.
const DESTRUCTIVE = /delete|remove|leave|unfriend/i;
const TRASH = /delete|remove/i; // trash icon only when something is deleted/removed; leave etc. get the alert icon

function CustomConfirmation({ open, setOpen, handleAgree, title }) {
  const handleCloseDialog = () => {
    setOpen(false);
  };
  const text = title ? title : "Are you sure you want to take this action?";

  return (
    <GrConfirmDialog
      open={open}
      onClose={handleCloseDialog}
      onConfirm={handleAgree}
      title={text}
      destructive={DESTRUCTIVE.test(text)}
      icon={TRASH.test(text) ? icons.trash : icons.alert}
    />
  );
}

export default CustomConfirmation;
